import Image from 'app/Components/Shared/Image/image';
import React, {memo, useContext} from 'react';
import classNames from 'classnames';
import BusinessInvoicesContext, {InvoiceOrderByEnum} from 'app/Components/Page/BusinessInvoicesPage/BusinessInvoicesContext';

const sortArrow = require('./images/icons-sort-arrow-not-select.svg');
const sortArrowSelected = require('./images/icons-sort-arrow-select.svg');

const sorting = [
  {
    label: 'חשבון',
    asc: InvoiceOrderByEnum.InvoiceNumber,
    desc: InvoiceOrderByEnum.InvoiceNumberDesc,
    default: InvoiceOrderByEnum.InvoiceNumberDesc,
  },
  {
    label: 'תאריך פרעון',
    asc: InvoiceOrderByEnum.PaymentDate,
    desc: InvoiceOrderByEnum.PaymentDateDesc,
    default: InvoiceOrderByEnum.PaymentDate,
  },
  {label: 'סכום', asc: InvoiceOrderByEnum.Amount, desc: InvoiceOrderByEnum.AmountDesc, default: InvoiceOrderByEnum.Amount},
];

const BusinessInvoicesSort = () => {
  const [{invoices, orderBy}, dispatch] = useContext(BusinessInvoicesContext);
  return invoices == null ? null : (
    <div className='BusinessInvoicesSort'>
      <div className='BusinessInvoicesSort__items'>
        {...sorting.map((item, i) => (
          <div
            key={i}
            onClick={() =>
              dispatch({type: 'order', orderBy: orderBy === item.asc ? item.desc : orderBy === item.desc ? item.asc : item.default})
            }
            className={classNames('BusinessInvoicesSort__item', {asc: orderBy === item.asc, desc: orderBy === item.desc})}>
            לפי {item.label}
            <Image
              className={classNames('BusinessInvoicesSort__icon', {asc: orderBy === item.asc})}
              src={orderBy === item.asc || orderBy === item.desc ? sortArrowSelected : sortArrow}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
export default memo(BusinessInvoicesSort);
